export const SearchFeedTypes = {
  ALL: 'all',
  CREATORS: 'creator',
  PRODUCTS: 'product',
  RECIPES: 'recipe'
};

export default {};
